module.exports = __webpack_public_path__ + "img/gear-K-high_88x88.06b4c3af.png";